// src/pages/SalesLedger/index.js
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Typography } from "antd";
import SalesLedgerFilters from "./components/SalesLedgerFilters";
import SalesLedgerTable from "./components/SalesLedgerTable";
import ReportDom from "../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";

const { Title } = Typography;

const SalesLedger = () => {
  const { message } = App.useApp();
  const { filters } = useSelector((state) => state.salesLedger);

  const reportRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Sales Ledger Report",
    removeAfterPrint: true,
  });

  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <Title level={4} style={{ margin: 0 }}>
              Sales Account Ledger
            </Title>
          }
          extra={
            <Button
              type="primary"
              icon={<PrinterOutlined />}
              onClick={handlePrint}
            >
              Print
            </Button>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <SalesLedgerFilters messageApi={message} />

        <Card className="shadow-md rounded-xl">
          <SalesLedgerTable />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Sales Ledger Report"
          mode="report-page"
          filters={filters}
          renderTable={() => (
            <SalesLedgerTable pagination={false} printMode={true} />
          )}
        />
      </div>
    </div>
  );
};

export default SalesLedger;
